class QuickAddVariants {
  constructor() {
    this.init();
  }

  init() {
    const productCards = document.querySelectorAll('.m-product-card');
    
    productCards.forEach(card => {
      // Evitar inicializar dos veces el mismo card
      if (card.dataset.quickAddInitialized) return;
      card.dataset.quickAddInitialized = 'true';
      
      const overlay = card.querySelector('.m-quick-add-overlay');
      if (!overlay) return;

      const hasVariants = overlay.querySelectorAll('.m-quick-add-variant-btn').length > 1;
      const isSingleVariant = overlay.querySelectorAll('.m-quick-add-variant-btn').length === 1;

      // Crear botón "+" para mobile (solo si no existe)
      let plusButton = card.querySelector('.m-quick-add-plus-btn');
      if (!plusButton) {
        plusButton = document.createElement('button');
        plusButton.className = 'm-quick-add-plus-btn';
        plusButton.innerHTML = '+';
        plusButton.style.display = 'none';
        
        const media = card.querySelector('.m-product-card__media');
        if (media) {
          media.style.position = 'relative';
          media.appendChild(plusButton);
        }
      }

      // Mostrar botón + solo en mobile
      const checkMobile = () => {
        if (window.innerWidth <= 768) {
          plusButton.style.display = 'flex';
        } else {
          plusButton.style.display = 'none';
        }
      };
      checkMobile();
      window.addEventListener('resize', checkMobile);

      // Desktop: hover para productos con variantes
      if (hasVariants) {
        card.addEventListener('mouseenter', () => {
          if (window.innerWidth > 768) {
            overlay.style.display = 'flex';
          }
        });

        card.addEventListener('mouseleave', () => {
          if (window.innerWidth > 768) {
            overlay.style.display = 'none';
          }
        });
      }

      // Producto con talla única
      if (isSingleVariant) {
        const singleBtn = overlay.querySelector('.m-quick-add-variant-btn');
        if (singleBtn) {
          singleBtn.textContent = 'Añadir al carrito'; // siempre, sin if de width
          
          card.addEventListener('mouseenter', () => {
            overlay.style.display = 'flex';
          });
          card.addEventListener('mouseleave', () => {
            overlay.style.display = 'none';
          });
        }
      }


      // Mobile: botón +
      plusButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        overlay.style.display = overlay.style.display === 'flex' ? 'none' : 'flex';
      });

      // Agregar al carrito
      const variantButtons = overlay.querySelectorAll('.m-quick-add-variant-btn:not(.m-disabled)');
      variantButtons.forEach(btn => {
        const originalText = btn.textContent;
        
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          const variantId = btn.dataset.variantId;
          
          btn.textContent = 'Agregando...';
          btn.disabled = true;

          try {
            const formData = {
              items: [{
                id: variantId,
                quantity: 1
              }]
            };

            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (response.ok) {
              btn.textContent = '✓ Agregado';
              
              // Actualizar el cart drawer usando el método nativo del tema
              const cartDrawer = document.querySelector('m-cart-drawer');
              if (cartDrawer && typeof cartDrawer.onCartDrawerUpdate === 'function') {
                cartDrawer.onCartDrawerUpdate(true);
              }

              // Disparar evento personalizado del tema
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));

              // Actualizar contador del carrito
              fetch(window.Shopify.routes.root + 'cart.js')
                .then(res => res.json())
                .then(cart => {
                  // Buscar el contador en diferentes posibles ubicaciones
                  const cartCountSelectors = [
                    '.m-cart-count',
                    '[data-cart-count]',
                    '.cart-count',
                    '#cart-count',
                    '.cart-link__bubble',
                    '[data-header-cart-count]'
                  ];
                  
                  cartCountSelectors.forEach(selector => {
                    const cartCount = document.querySelector(selector);
                    if (cartCount) {
                      cartCount.textContent = cart.item_count;
                      if (cart.item_count > 0) {
                        cartCount.style.display = '';
                      }
                    }
                  });
                  
                  // Abrir el cart drawer automáticamente
                  setTimeout(() => {
                    const openButton = document.querySelector('#m-cart-icon-bubble') || 
                                     document.querySelector('.m-cart-icon-bubble');
                    if (openButton) {
                      openButton.click();
                    }
                  }, 400);
                });
              
              setTimeout(() => {
                overlay.style.display = 'none';
                btn.textContent = originalText;
                btn.disabled = false;
              }, 1500);
            } else {
              throw new Error(data.description || 'Error al agregar al carrito');
            }
          } catch (error) {
            console.error('Error:', error);
            btn.textContent = 'Error';
            setTimeout(() => {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 2000);
          }
        });
      });
    });
  }
}

// Inicializar
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new QuickAddVariants());
} else {
  new QuickAddVariants();
}

// Re-inicializar cuando se cargan más productos (infinite scroll / paginación)
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && (node.classList.contains('m-product-card') || node.querySelector('.m-product-card'))) {
            // Esperar un momento para que el DOM se estabilice
            setTimeout(() => {
              new QuickAddVariants();
            }, 100);
          }
        });
      }
    });
  });

  // Observar cambios en el contenedor de productos
  const productContainers = document.querySelectorAll('[data-collection-container], .m-product-list, .m-main-collection, main');
  productContainers.forEach(container => {
    if (container) {
      observer.observe(container, {
        childList: true,
        subtree: true
      });
    }
  });
}
